import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../icon/icon';
import { RootState } from '../../../../redux/store';
import { SWITCH_MODAL } from '../../../../redux/types';
import PinLoader from '../../loaders/pinLoader/pinLoader';

import './pin.scss';
interface IPin {
  isPinned?: boolean;
  clickHandler?: () => void;
  modal?: boolean;
  className?: string;
  loading?: boolean;
}

const Pin: React.FC<IPin> = ({ isPinned, clickHandler, className, loading }) => {
  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);
  const dispatch = useDispatch();
  const pinClickHandler = impersonate ? () => dispatch({ type: SWITCH_MODAL }) : clickHandler;

  return (
    <div className={'pin-wrapper'}>
      {loading && <PinLoader />}
      <Icon className={`${className} pointer ${isPinned ? 'pinned' : ''}`} name={`${isPinned ? 'fas' : 'far'} fa-thumbtack`} onClick={pinClickHandler} />
    </div>
  );
};

export default Pin;
